(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairGoalsReportController', PhysicalFairGoalsReportController);
    PhysicalFairGoalsReportController.$inject = ['$uibModal', 'ExpoService', 'PhysicalFairService','toastr'];
    function PhysicalFairGoalsReportController($uibModal, ExpoService, PhysicalFairService, toastr) {
        var vm = this;
        vm.flag                  = false;
        vm.result                = [];
        //vm.goalResult            = [];
        vm.expoSelected          = [];
        vm.semesterSelected      = [];
        vm.semester              = [];
        //vm.sellerResult          = [];
        vm.i                     = -1;
        vm.selectExpo            = selectExpo;
        vm.getSemester           = getSemester;
        vm.selectExpoBySemester  = selectExpoBySemester;
        vm.getByFilter           = getByFilter;
        vm.citySelected          = [];
        vm.saveGoal              = saveGoal;
        vm.reachedClass          = reachedClass;

        /*PAGINATION*/
        vm.pageChanged           = pageChanged;
        vm.setPage               = setPage;
        vm.to                    = [];
        vm.totalItems            = [];
        vm.currentPage           = null;
        vm.itemsPerPage          = [];
        vm.page                  = 1;

        function activate() {
            vm.selectExpo();
            vm.getSemester();
        }

        function getSemester () {
            ExpoService.getSemester().then(function(response){
                 vm.semester = response.data;
            }).catch(function(err) {
            });
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                vm.expo = response.data;
            }).catch(function(err) {
            });
        }

        function selectExpoBySemester () {
            var query = [];
            query['semester'] = vm.semesterSelected.semester;
            ExpoService.getExpoBySemester(query).then(function(response){
                vm.expo = response.data;
            }).catch(function(err) {
            });
        }

        function getByFilter() {
            vm.flag = false;
            vm.query = {};
            if(typeof vm.expoSelected !== 'undefined') {
                vm.query['expo_id'] = vm.expoSelected.id;
            }
            if(typeof vm.semesterSelected !== 'undefined') {
                vm.query['semester'] = vm.semesterSelected.semester;
            }
            if(vm.page !== null)
                vm.query['page'] = vm.page;
            vm.query['goal_type'] = 'report';
            /* Load variables to CSV */
           var serviceSearch = PhysicalFairService.getByFilterGoals(vm.query);
           return  serviceSearch.then(function(response){
               vm.result.goals = response.data;
               return PhysicalFairService.getExpos(vm.query);
            }).then(function(response){
               vm.result.expos = response.data;
               if(vm.result.goals.length == 0) {
                   vm.noResultMessage = 'Sorry, no results were found!';
                   vm.flag = false;
               } else {
                   vm.noResultMessage = '';
                   vm.flag = true;
               }
            }).catch(function(err){
            });
        }

        function saveGoal(expo_id, seller_id, goal_money, seller) {
           var query =  [];
            if(typeof expo_id !== 'undefined') {
                query['expo_id'] = expo_id;
                if(typeof seller_id !== 'undefined') {
                    query['seller_id'] = seller_id;
                    if(typeof goal_money !== 'undefined') {
                        query['goal_money'] = goal_money;

                        if(typeof vm.query['expo_id'] !== 'undefined') {
                            query['filter_expo_id'] = vm.query['expo_id'];
                        }
                        if(typeof vm.query['semester'] !== 'undefined') {
                            query['filter_semester'] = vm.query['semester'];
                        }

                        PhysicalFairService.saveGoal(query).then(function(response) {
                            if(typeof response.data !== 'undefined') {
                                seller.total = response.data;
                                toastr.success('Successfully edited!');
                            } else {
                                toastr.error('Try again later!', 'Error');
                            }
                        }).catch(function(err) {
                            toastr.danger('Error: '+err);
                        });
                    }
                }
            }
        }

        function reachedClass(goal_money, invoice_total) {
            if(goal_money <= invoice_total) {
                return 'label-success';
            } else if(goal_money * 0.8 <= invoice_total && goal_money > invoice_total) {
                return 'label-warning';
            } else {
                return 'label-danger';
            }
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        activate();
    }
})();